import * as React from 'react';

import {useContext} from "react";
import {useTranslation} from "react-i18next";

import {GridRenderCellParams, GridSortModel, GridValueFormatterParams} from "@mui/x-data-grid";


import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import {OAuthContext} from "../../../context/OAuthContext";
import {ApplicationsTableContext} from "../../../context/ApplicationsTableContext";
import {StyledLink, StyledDataGrid} from "../styled";
import {formatDateToLocale} from "../utils";
import {toRem} from "../../../themes/utils";

const HeaderTitle = ({title}:{title: string}) => {
    return <Box sx={{ p: toRem(16)}}>
        <Typography variant="body1">{title}</Typography>
    </Box>
}

const ApplicationsTable = () => {
    const {oauthData} = useContext(OAuthContext);
    const {title, filteredLists, loadingApplications} = useContext(ApplicationsTableContext);
    const [sortModel, setSortModel] = React.useState<GridSortModel>([
        {field: "signatureDate", sort: "desc"}
    ]);

    const { t } = useTranslation('common');

    const getSalesPartnerName = (params: GridRenderCellParams) => {
        return `${params.row.salesPartner.name}`;
    }

    const getEditorsName = (params: GridRenderCellParams) => {
        const name = params.row.editor?.name;
        return  name ? `${params.row.editor.name}` : "";
    }

    const getApplicantName = (params: GridRenderCellParams) => {
        if (params.row.anonymized)
            return t("anonymized");
        return params.row.baseData.recruitCompany ? params.row.baseData.recruitCompany : `${params.row.baseData?.recruitContacts[0]?.lastName} ${params.row.baseData?.recruitContacts[0]?.firstName}`
    }

    const getDate = (params: GridRenderCellParams) => {
        return params.row.recruiterSignatureDate ?? "";
    }

    const formatDate = (params: GridValueFormatterParams) => {
        return params.value ? formatDateToLocale(params.value, oauthData) : "";
    }

    const getCellRender = (params: GridRenderCellParams<number>) => {
        return <StyledLink to={`/applications/${params.row.id}`}>{params.value}</StyledLink>
    }

    const getStatus = (params: GridRenderCellParams) => {
        return t(params.row.status);
    }

    const getAppType = (params: GridRenderCellParams) => {
        return t(`application_status_${params.row.type}`);
    }

    const getMandate = (params: GridRenderCellParams) => {
        return t(`mandate_${params.row.mandate}`);
    }

    const columns = [
        {field: "applicationNumber" , headerName: t("application_nmbr"), renderCell: getCellRender, flex: 1},
        {field: "mandate" , headerName: t("application_mandate"), renderCell: getMandate, flex: 1},
        {field: "applicant" , headerName: t("applicant"), valueGetter: getApplicantName, flex: 1},
        {field: "salesPartner" , headerName: t("sponsor"), valueGetter: getSalesPartnerName, flex: 1},
        {field: "signatureDate" , headerName: t("signed_at"), valueGetter: getDate, valueFormatter: formatDate, flex: 1},
        {field: "status" , headerName: t("status"), valueGetter: getStatus,flex: 1},
        {field: "type" , headerName: t("application_type"), valueGetter: getAppType, flex: 1},
        {field: "editor" , headerName: t("editor"), valueGetter: getEditorsName, flex: 1},
    ]

    return (
        <Box sx={{ width: 'auto' }}>
            {filteredLists && <StyledDataGrid autoHeight loading={loadingApplications} columnThreshold={0} components={{Toolbar: () => <HeaderTitle title={title}/> }} componentsProps={{ pagination: {
                    labelRowsPerPage: t("rows_per_page")
                }}} rows={filteredLists} columns={columns} sortModel={sortModel} onSortModelChange={setSortModel} pagination localeText={{noRowsLabel: t("no_data")}} />}
        </Box>
    );
};

export default ApplicationsTable;